import SvgIcon from '@mui/material/SvgIcon'

import { IconProps } from './types'

const HomeIcon = (props: IconProps = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M5.8,19H8.9V13.81a1,1,0,0,1,1-1h4.14a1,1,0,0,1,1,1V19h3.1V9.68L12,5,5.8,9.68ZM3.73,19V9.68A2.12,2.12,0,0,1,4,8.75,2.06,2.06,0,0,1,4.56,8l6.2-4.65a2.08,2.08,0,0,1,2.48,0L19.44,8a2.06,2.06,0,0,1,.61.73,2.12,2.12,0,0,1,.22.93V19a2.08,2.08,0,0,1-2.07,2.07H14.07a1,1,0,0,1-.74-.3A1,1,0,0,1,13,20V14.85H11V20a1,1,0,0,1-.3.74,1,1,0,0,1-.74.3H5.8A2.08,2.08,0,0,1,3.73,19Z" />
    </SvgIcon>
  )
}
export default HomeIcon
